<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
      :permission="permission" pageName="AdDailyAccountReport" />
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

function parseDateTime(value) {
  if (!value) {
    return null;
  }
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'number') {
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }
  if (typeof value === 'string') {
    const normalizedValue = value.includes('T') ? value : value.replace(/-/g, '/');
    const date = new Date(normalizedValue);
    return isNaN(date.getTime()) ? null : date;
  }
  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
}

function formatReportDate(value) {
  const date = parseDateTime(value);
  if (!date) {
    return value || '-';
  }
  const reportDate = new Date(date.getTime() - ONE_DAY_MS);
  const year = reportDate.getFullYear();
  const month = String(reportDate.getMonth() + 1).padStart(2, '0');
  const day = String(reportDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export default {
  name: 'AdDailyAccountReport',
  components: { CommonTable },
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'groupId',
        placeholder: '账户分组',
        type: 'select',
        selectUrl: '/oceanEngineAdvertiserGroup/getAll',
        selectData: [],
      }, {
        name: 'reportId',
        placeholder: '报表Id',
        type: 'input'
      }, {
        name: 'advertiserId',
        placeholder: '广告主名称',
        type: 'select',
        selectUrl: '/oceanEngineAdvertiser/getAllInfo',
        valueKey: 'advertiserId',
        selectData: [],
      }, {
        name: 'advertiserId',
        placeholder: '广告主Id',
        type: 'input'
      }, {
        name: 'startTime',
        placeholder: '开始时间',
        type: 'dateTime'
      }, {
        name: 'endTime',
        placeholder: '结束时间',
        type: 'dateTime'
      }],
      permission: {
        add: 'adDailyAccountReport:add',
        update: 'adDailyAccountReport:update',
        delete: 'adDailyAccountReport:delete',
        deleteBatch: 'adDailyAccountReport:deleteBatch'
      },
      url: {
        get: '/adDailyAccountReport/listByCondition',
        add: '/adDailyAccountReport/add',
        update: '/adDailyAccountReport/update',
        delete: '/adDailyAccountReport/delete',
        delete_batch: '/adDailyAccountReport/deleteBatch',
        status: '/adDailyAccountReport/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      },
      {
        field: 'agentId',  // 字段名
        label: '代理',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'reportId',  // 字段名
        label: '报表Id',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'advertiserId',  // 字段名
        label: '广告主Id',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'accountName',  // 字段名
        label: '账号名称',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'dailyCreateCount',  // 字段名
        label: '创建数量',  // 字段显示名称
        sort: true,  // 是否排序
        show: true,  // 是否展示
        sortable: 'custom',
      }, {
        field: 'totalConsumption',  // 字段名
        label: '账户消耗',  // 字段显示名称
        sort: true,  // 是否排序
        show: true,  // 是否展示
        sortable: 'custom',
      }, {
        field: 'totalOrderNum',  // 字段名
        label: '订单数',  // 字段显示名称
        sort: true,  // 是否排序
        show: true,  // 是否展示
        sortable: 'custom',
      }, {
        field: 'totalAmount',  // 字段名
        label: '成单金额',  // 字段显示名称
        sort: true,  // 是否排序
        show: true,  // 是否展示
        sortable: 'custom',
      }, {
        field: 'avgRoi',  // 字段名
        label: 'ROI',  // 字段显示名称
        sort: true,  // 是否排序
        show: true,  // 是否展示
        sortable: 'custom',
      },
      {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
        formatter: (row) => formatReportDate(row.createTime),
      }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',  // 字段名
            label: 'agentId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入agentId',
            rules: [
              { required: true, message: 'agentId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'advertiserId',  // 字段名
            label: 'advertiserId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入advertiserId',
            rules: [
              { required: true, message: 'advertiserId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'accountName',  // 字段名
            label: 'accountName',  // 字段显示名称
            type: 'input',
            placeholder: '请输入accountName',
            rules: [
              { required: true, message: 'accountName不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'dailyCreateCount',  // 字段名
            label: 'dailyCreateCount',  // 字段显示名称
            type: 'input',
            placeholder: '请输入dailyCreateCount',
            rules: [
              { required: true, message: 'dailyCreateCount不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'totalConsumption',  // 字段名
            label: 'totalConsumption',  // 字段显示名称
            type: 'input',
            placeholder: '请输入totalConsumption',
            rules: [
              { required: true, message: 'totalConsumption不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'totalOrderNum',  // 字段名
            label: 'totalOrderNum',  // 字段显示名称
            type: 'input',
            placeholder: '请输入totalOrderNum',
            rules: [
              { required: true, message: 'totalOrderNum不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'totalAmount',  // 字段名
            label: 'totalAmount',  // 字段显示名称
            type: 'input',
            placeholder: '请输入totalAmount',
            rules: [
              { required: true, message: 'totalAmount不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'avgRoi',  // 字段名
            label: 'avgRoi',  // 字段显示名称
            type: 'input',
            placeholder: '请输入avgRoi',
            rules: [
              { required: true, message: 'avgRoi不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped></style>
